// libs
import React, { memo } from "react";
import styled from "@emotion/styled";

// constants
import { FONTS } from "shared/styles/base";

// styles
const Container = styled.div`
    color: #fff;
    font-family: ${FONTS.CERA};
    flex: 1 0 auto;

    @media (max-width: 580px) {
        margin-top: 20px;

        &:first-of-type {
            margin-top: 0;
        }
    }

    .title {
        font-size: 1rem;
        color: #fff;
        margin-bottom: 13px;
        font-weight: 600;
        text-transform: uppercase;
    }
`;

// defs
interface ISubSectionProps {
    title: string;
    isTitleCaps?: boolean;
    hideOnIpad?: boolean;
    children: React.ReactNode;
}

function SubSection({ title, children }: ISubSectionProps) {
    return (
        <Container>
            <div className="title">{title}</div>
            {children}
        </Container>
    );
}

export default memo(SubSection);
